import { withInstall } from '@ll-plus/utils'

import Divider from './src/divider.vue'

export const LlDivider = withInstall(Divider)
export default LlDivider
export * from './src/divider'

declare module 'vue' {
  export interface GlobalComponents {
    LlDivider: typeof Divider
  }
}
